var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { ref: "tableList", staticClass: "yxtbiz-select-rank-table-list" },
    [
      _c(
        "yxt-table",
        {
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "row-key": function (row) {
              return row.sourceId
            },
            height: "100%",
          },
          on: { select: _vm.selectRow, "select-all": _vm.selectAll },
        },
        [
          _c("yxt-table-column", {
            attrs: {
              type: "selection",
              "reserve-selection": true,
              width: "45",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$t("pc_biz_select_rank_title"),
              width: "250",
            },
          }),
          _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_select_rank_content"),
              width: "300",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.showName(scope.row)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }